<template>
  <ContentMetrics>
    <template>
      <Metric :value="summary.waiting" :title="titles.waiting" :border="true" />
      <Metric :value="summary.exceeded" :title="titles.exceeded" :border="true" />
      <Metric :value="summary.departed" :title="titles.departed" />
    </template>
  </ContentMetrics>
</template>

<script>
import ContentMetrics from '@/components/Levels/ContentMetrics'
import Metric from '@/components/Levels/Metric'
import { summarizeRoutes } from '@/utils/routeSummary'
import { SUMMARY_TITLES } from '../kitchenWaitConstants'

export default {
  name: 'DeliverySummary',
  components: {
    ContentMetrics,
    Metric
  },
  props: {
    routes: {
      type: Array,
      required: true
    }
  },
  computed: {
    titles () {
      return SUMMARY_TITLES
    },
    summary () {
      return summarizeRoutes(this.routes)
    }
  }
}
</script>
